import { http } from '@pendo/http';

export function createJourney (journey) {
    return http.post('/api/s/_SID_/journey', journey).then((res) => res.data);
}

export function getAllJourneys () {
    return http.get('/api/s/_SID_/journey').then((res) => res.data);
}

export function updateJourney (journey) {
    return http.put(`/api/s/_SID_/journey/${journey.id}`, journey).then((res) => res.data);
}

export function updateSchedule (id, scheduleData) {
    return http.put(`/api/s/_SID_/journey/${id}/schedule`, scheduleData).then((res) => res.data);
}

export function deleteJourney (id) {
    return http.delete(`/api/s/_SID_/journey/${id}`);
}

export function getJourneyById (id) {
    return http.get(`/api/s/_SID_/journey/${id}`).then((res) => res.data);
}

// TODO: addGraphMessage
export function addEngagementMessage (journeyId, engagementId, message) {
    return http
        .post(`/api/s/_SID_/journey/${journeyId}/engagement/${engagementId}/message`, message)
        .then((res) => res.data);
}

// TODO: deleteGraphMessage
export function deleteEngagementMessage (journeyId, engagementId, messageId) {
    return http
        .delete(`/api/s/_SID_/journey/${journeyId}/engagement/${engagementId}/message/${messageId}`)
        .then((res) => res.data);
}

// TODO: updateMessageDuration to graph message
export function updateMessageDuration (journeyId, engagementId, messageId, durationInDays) {
    return http
        .put(`/api/s/_SID_/journey/${journeyId}/engagement/${engagementId}/message/${messageId}`, {
            durationInDays,
        })
        .then((res) => res.data);
}

// TODO: remove syncEntitiesFromProvidersByJourneyId once non-branched journeys are not supported anymore
export function syncEntitiesFromProvidersByEngagementId (journeyId, engagementId) {
    return http
        .put(`/api/s/_SID_/journey/${journeyId}/engagement/${engagementId}/message/sync/external/provider`)
        .then((res) => res.data);
}

export function syncEntitiesFromProvidersByJourneyId (journeyId) {
    return http.put(`/api/s/_SID_/journey/${journeyId}/message/sync/external/provider`).then((res) => res.data);
}

export function updateJourneyStatus (journeyId, status) {
    return http.put(`/api/s/_SID_/journey/${journeyId}/status`, { status }).then((res) => res.data);
}

export function updateMessageGraph (journeyId, messageGraph) {
    return http.put(`/api/s/_SID_/journey/${journeyId}/graph`, { messageGraph }).then((res) => res.data);
}

export function updateJourneyAudience (journeyId, audience, audienceUiHint, reachInactiveVisitors = false, retainVisitorsAfterEntry = false) {
    return http
        .put(`/api/s/_SID_/journey/${journeyId}/audience`, { audience, audienceUiHint, reachInactiveVisitors, retainVisitorsAfterEntry })
        .then((res) => res.data);
}

export function getAllEmailFieldsOfJourney (store) {
    const messages = store?.getters?.['journeys/getMessages'] || [];
    const emailMessages = messages.filter((message) => message.type === 'Email');
    const fields = emailMessages
        .map((email) => {
            const emailEntity = store?.getters?.['emails/getEmailById']?.(email.id);

            return emailEntity?.emailSettings?.recipientMetadataPropertyName;
        })
        .filter((field) => field != null && field !== '');

    // Remove duplicates
    return [...new Set(fields)];
}
